<template>
	<v-btn @click="showLogs">Logs</v-btn>
</template>

<script setup lang="ts">
import { useInstanceWorkspacesStore } from "../../../store/i-workspace";
import { useDomainStore } from "../../../store/domain";
import { useDebugStore } from "../../../store/debug";
import { api } from "@lr-notitia/notitia-operator/client";

const workspacesStore = useInstanceWorkspacesStore();
const domainStore = useDomainStore();
const debugStore = useDebugStore();

async function showLogs() {
	if (!domainStore.isEditorOrAdmin) return;
	if (!workspacesStore.openedWorkspace) return;

	const logs = await api()
		.domain(domainStore.domain.id)
		.workspace(workspacesStore.openedWorkspace.id)
		.logs()
		.get()
		.then((data) => data)
		.catch((error) => {
			console.error("Error fetching logs:", error);
			return null;
		});

	if (!logs) {
		console.error("No logs available");
		return;
	}

	const lines = logs.split("\n");
	debugStore.setAltKeyHeld(false);
	const newWindow = window.open("");
	lines.forEach((line) => {
		newWindow?.document.write(line + "<br>");
	});
}
</script>
